import { AppHelper } from "../appHelper.js"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp.js";
import { Helper } from "../core/util/helper.js";
import { MetaDataHelper } from "../core/util/metaDataHelper.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { General } from "../../siteManagement/general.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Config } from "../core/config/config.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import Skills from "../core/components/skills.js";
import { TreeNodeVm } from "../generalSettings/skills/skillsInterfaces.js";
import { PageTitleProps } from "../core/components/pageTitle.js";
import React from "react";
export class MachineApp extends React.Component<MachineAppProps, any> {
    common = new AppHelper();
    translations: {};
    allocationsGridOptions: {};
    dsMaogrnr: Array<{ Maogrnr: number, Maogruppe: string }> = [];
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    deleteEnabled = false;
    isDeleted = false;

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this._refreshDeleteEnabled();
        this.props.context.allocationsGrid = this.allocationsGridOptions;
    }

    private _refreshDeleteEnabled() {
        this.deleteEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite
    }
    private deleteMachine() {
        HTTPService.post<JsonResultClass>('Machine/Delete?maschnr=' + encodeURIComponent(this.props.entity.MaschNr))
            .then(result => {
                if (result.Code === 0) {
                    NotificationHelper.showSuccessMessage(result.Message);
                    if (this.common.isWindow) {
                        this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                        this.common.sheetWrapper.hide();
                    } else {
                        this.deleteEnabled = false;
                        this.isDeleted = true;
                        this.props.entity.RecordRight.CanWrite = false;
                        this.setState({});
                        setTimeout(() => {
                            window.location.href = Config.baseUrl + "DynamicSearch/Machine";
                        }, 1000);
                    }
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }
    remove = async () => {
        const isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOk) {
            this.deleteMachine();
        }
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Gruppe":
                if (value === null) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Schluessel", null);
                }
            case "entity.Breitegrad": {
                if (value === this.props.entity.Breitegrad)
                    return;
            }
            case "entity.Laengegrad": {
                if (value === this.props.entity.Laengegrad)
                    return;
            }
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    handleIsSearchFieldFullObjectModel = (field, dataItem) => {
        let changed = true;
        switch (field.model) {
            case "entity.Gruppe":
                MetaDataHelper.setFieldValue(this.props.entity, "entity.Schluessel", dataItem.schluessel);
                break;
            default:
                changed = false;
                break;
        }

        if (changed) {
            this.common.handleFieldChange({ model: "" }, null, null);
        }
    }

    handleDataLoaded = (field, data) => {
        if (field.model == "entity.Maogrnr") {
            this.dsMaogrnr = data;
        }
    }

    save = async (closeAfterSave) => {
        for (const loadedModule of this.common.getLoadedModules()) {
            loadedModule.Save();
        }
        if (this.common.validate()) {
            const result = await HTTPService.post<JsonResultClass>("Machine/Save", this.props.entity);
            if (result.Code === 0) {
                if (this.props.entity.IsNew) {
                    General.Functions.HistoryState.replaceState("Machine/Edit?id=" + encodeURIComponent(this.props.entity.MaschNr));
                }
                let indivData = result.Data.IndividualFields;
                Helper.updateEntity(this.props.entity, result.Data);
                for (var key in indivData) {
                    this.props.entity.IndividualFields[key] = indivData[key];
                }
                this.props.entity.IsNew = false;
                this._refreshDeleteEnabled();
                $(window).trigger("saveSkills", this.props.entity);
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, closeAfterSave);
        }
    }

    componentDidMount() {
        if (Helper.hasValue(this.props.context.initAddress)) {
            this.handleFieldChange({ model: "entity.AdrNr" }, this.props.context.initAddress, true);
        }
    }

    private onTreeDataChanged = (treeData: TreeNodeVm[]) => {
        this.common.setEntityDirtyState(true);
    }

    createSkillsMachine = () => {
        let entity: any = this.props.entity;
        return <Skills entity={entity} runningContext="machine" onTreeDataChanged={this.onTreeDataChanged}
            title={Helper.getTranslation["WebSMS.UserSettings.Skills.MachineSkills"]} editable={true} />;
    }

    createSkillsMachineType = () => {
        let entity: any = this.props.entity;
        return <Skills entity={entity} runningContext="machinetype" onTreeDataChanged={this.onTreeDataChanged}
            title={Helper.getTranslation["WebSMS.Machine.MachineType"]} editable={true} />;
    }

    openCockpit = () => {
        General.Sheet.Manager.createSheetWithUrl(`Cockpit/IndexMachine?id=${encodeURIComponent(this.props.entity.MaschNr)}`, null, null, false);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(this.props), { apphelper: this.common, handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel, handleDataLoaded: this.handleDataLoaded });
        const titleProps: PageTitleProps = {
            title: this.props.title,
            value: this.props.entity.MaschNr,
        };
        return <CommonApp {...props} titleProps={titleProps} />;
    }
};

export interface MachineAppProps extends AppBaseProps {
    entity: EntityMachine;
    context: MachineAppPropsContext;
}

export interface EntityMachine extends Entity {
    MaschNr: string;
    Isguid: string;
    Breitegrad: number;
    Laengegrad: number;
}

interface MachineAppPropsContext extends Context {
    allocationsGrid?: {};
    initAddress: string;
}